
import { IconButton, Icon, Stack, Tooltip, Button, useDisclosure, Modal, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, Text, GridItem, Grid, Center, Badge } from '@chakra-ui/react';
import { BsShop } from "react-icons/bs";
import AttachmentImage from '../../../AttachmentImage'
import { Tool } from '../../../../classes/ToolFactory';
import Game from '../../../../classes/Game';
import { CustomRegionAttachment, withGame } from '../../helpers';


const comingSoon = ['chloroform', 'paddle', 'feather', 'rope']

function Shop({ game }: { game?: Game}) {

  const { isOpen, onClose, onOpen } = useDisclosure()
  const { isOpen: tooltipOpen, onOpen: onTooltipOpen, onClose: onTooltipClose } = useDisclosure()

  if(!game) {
    return null
  }

  const onAddTool = (tool: Tool) => () => {
    const success = game.buyItem(tool)
    if(success) {
      console.log('success')
    } else {
      console.log('error')
    }
  }

  return (<>
    <Tooltip isOpen={tooltipOpen} label={'Shop'} placement="left" shouldWrapChildren>
      <IconButton
        onClick={() => {
          if(isOpen) {
            onClose()
            onTooltipOpen()
          } else {
            onOpen()
            onTooltipClose()
          }
        }}
        onMouseEnter={() => {
          !isOpen && onTooltipOpen()
        }}
        onMouseLeave={onTooltipClose}
        aria-label="inventory">
        <Icon as={BsShop} />
      </IconButton>
    </Tooltip>
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="xl">
      <ModalContent>
        <ModalHeader>Shop</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
        <Grid templateColumns={{ base: 'repeat(2, 1fr)', sm: 'repeat(3, 1fr)', md: 'repeat(4, 1fr)' }} gap={4}>
            {game.toolList.map((t, i) => (<GridItem key={t.name}>
              <Button onClick={onAddTool(t)} h={28} borderWidth={2} p={1} pb={2} w="100%" bg="white" display="block" position="relative" disabled={comingSoon.includes(t.name)}>
                <Stack align="center" h="100%">
                  <Center flex={1} mt={1}>
                    <AttachmentImage key={i} attachment={t.attachment as CustomRegionAttachment} maxHeight={65} />
                  </Center>
                  <Text textTransform="capitalize" style={{marginTop: 0}}>{t.name}</Text>
                </Stack>
                {!comingSoon.includes(t.name) && <Badge position="absolute" top={1} right={1} colorScheme="green" p={1} borderRadius="md">${t.cost}</Badge>}
                {comingSoon.includes(t.name) && <Badge position="absolute" top={1} right={1} colorScheme="red" p={1} borderRadius="md">Coming soon</Badge>}
              </Button>
            </GridItem>))}
          </Grid>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme='blue' onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  </>)

}

export default withGame(Shop)


